/**
 * DecisionTimeChart Component - Phase 2C-4
 *
 * Bar chart showing decision time distribution.
 * BSL Compliant: Neutral blue colors, factual labels only.
 */

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { ChartWrapper } from './ChartWrapper';

interface DecisionTimeChartProps {
  data: {
    labels?: string[];
    values?: number[];
  } | null;
  loading?: boolean;
  error?: string | null;
}

export function DecisionTimeChart({
  data,
  loading,
  error,
}: DecisionTimeChartProps): JSX.Element {
  // Transform data for Recharts
  const chartData = data?.labels?.map((label, index) => ({
    name: label,
    count: data.values?.[index] || 0,
  })) || [];

  const isEmpty = !chartData.length || chartData.every(d => d.count === 0);

  return (
    <ChartWrapper
      title="Decision Time Distribution"
      subtitle="Time taken to submit predictions"
      loading={loading}
      error={error}
      empty={isEmpty}
      emptyMessage="No decision time data recorded"
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
          <XAxis
            dataKey="name"
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            axisLine={{ stroke: '#475569' }}
          />
          <YAxis
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            axisLine={{ stroke: '#475569' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1e293b',
              border: '1px solid #334155',
              borderRadius: '8px',
              color: '#f8fafc',
            }}
            labelStyle={{ color: '#94a3b8' }}
          />
          <Bar
            dataKey="count"
            fill="#3b82f6"
            radius={[4, 4, 0, 0]}
            name="Decisions"
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartWrapper>
  );
}